var _excluded = ["account", "addOnLeft", "addOnRight", "height", "onClick", "onKeyDown", "selected", "loading", "loadingAltText"];
var _jsxFileName = "/repo/packages/webassets/src/components/AccountCard/AccountCard.tsx",
  _this = this;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { defineMessages, FormattedDateTime, T } from '@sm/intl';
import { Box } from '@wds/box';
import { ProgressCircle } from '@wds/progress-circle';
import { Typography } from '@wds/typography';
import { WebAssetsThemeWrapper } from '../../theme';
import AccountName from './AccountName/AccountName';
import AccountTypeBadge from './AccountTypeBadge/AccountTypeBadge';
import useStyles from './useStyles';
export var ACCOUNT_CARD_TEST_ID = 'AccountPicker__AccountCard';
var COPY = defineMessages({
  lastLogin: {
    id: 'AccountCard.lastLoginDate',
    defaultMessage: 'Last login {date}',
    description: '[Type: Label][Vis.: med] - Label for a field that shows the date when user last logged into an account'
  }
});
var CardSpinner = function CardSpinner(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? undefined : _ref$className,
    altText = _ref.altText;
  return /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    flexJustify: "center",
    flexAlign: "center",
    className: className,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 28,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(ProgressCircle, {
    size: "sm",
    continuous: true,
    valueText: altText,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 34,
      columnNumber: 7
    }
  }));
};
var AccountCard = function AccountCard(props) {
  return /*#__PURE__*/React.createElement(WebAssetsThemeWrapper, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 41,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(AccountCardContent, Object.assign({}, props, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 42,
      columnNumber: 7
    }
  })));
};

/**
 * Interactive card for rendering a `LinkedIdentity`
 */
var AccountCardContent = function AccountCardContent(_ref2) {
  var account = _ref2.account,
    addOnLeft = _ref2.addOnLeft,
    addOnRight = _ref2.addOnRight,
    height = _ref2.height,
    onClick = _ref2.onClick,
    onKeyDown = _ref2.onKeyDown,
    _ref2$selected = _ref2.selected,
    selected = _ref2$selected === void 0 ? false : _ref2$selected,
    _ref2$loading = _ref2.loading,
    loading = _ref2$loading === void 0 ? false : _ref2$loading,
    _ref2$loadingAltText = _ref2.loadingAltText,
    loadingAltText = _ref2$loadingAltText === void 0 ? '' : _ref2$loadingAltText,
    props = _objectWithoutProperties(_ref2, _excluded);
  var _useStyles = useStyles({
      selected: selected,
      loading: loading,
      height: height
    }),
    accountCard = _useStyles.accountCard,
    accountCardDynamic = _useStyles.accountCardDynamic,
    accountCardBody = _useStyles.accountCardBody,
    accountType = _useStyles.accountType,
    spinner = _useStyles.spinner;
  var mainContent = /*#__PURE__*/React.createElement("div", {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 75,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: accountType,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 77,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(AccountTypeBadge, {
    packageId: parseInt(account.packageId, 10),
    teamName: account.teamName || undefined,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 78,
      columnNumber: 9
    }
  })), /*#__PURE__*/React.createElement(Box, {
    mt: 4,
    display: "flex",
    flexDirection: "column",
    flexJustify: "flex-start",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 84,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(AccountName, {
    username: account.username,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 90,
      columnNumber: 9
    }
  }), account.lastLoggedInAt ? /*#__PURE__*/React.createElement(Typography, {
    variant: "bodySm",
    color: "darkMuted",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 92,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(T, {
    desc: COPY.lastLogin,
    values: {
      date: FormattedDateTime({
        value: new Date(account.lastLoggedInAt),
        month: 'short',
        day: 'numeric',
        year: 'numeric'
      })
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 93,
      columnNumber: 13
    }
  })) : /*#__PURE__*/React.createElement(React.Fragment, null)));
  var leftContent = addOnLeft ? /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    flexAlign: "center",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 113,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(Box, {
    mr: 4,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 114,
      columnNumber: 7
    }
  }, addOnLeft)) : /*#__PURE__*/React.createElement(React.Fragment, null);
  var rightContent = addOnRight ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    style: {
      flexGrow: 1
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 122,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    flexAlign: "center",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 123,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Box, {
    ml: 2,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 124,
      columnNumber: 9
    }
  }, addOnRight))) : /*#__PURE__*/React.createElement(React.Fragment, null);
  var cardProps = _objectSpread({
    role: 'button',
    onKeyDown: onKeyDown,
    onClick: onClick,
    tabIndex: 0
  }, props);
  return /*#__PURE__*/React.createElement(Box, {
    mb: 2,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 140,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("div", Object.assign({
    "data-testid": ACCOUNT_CARD_TEST_ID,
    className: "".concat(accountCard, " ").concat(accountCardDynamic)
  }, cardProps, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 141,
      columnNumber: 7
    }
  }), loading ? /*#__PURE__*/React.createElement("div", {
    className: accountCardBody,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 147,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(CardSpinner, {
    className: spinner,
    altText: loadingAltText,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 148,
      columnNumber: 13
    }
  })) : /*#__PURE__*/React.createElement("div", {
    className: accountCardBody,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 151,
      columnNumber: 11
    }
  }, leftContent, mainContent, rightContent)));
};
export default AccountCard;
//# sourceMappingURL=AccountCard.js.map